<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.roleManagement") }}</h4>
    </div>
    <div class="wrap_con type_bt_wrap">
      <div class="mb-5 pb-3">
        <div class="float-end">
          <div class="list_top_search d-flex">
            <input
              type="text"
              id="searchWord"
              v-model="form.searchWord"
              name="searchWord"
              value=""
              class="m-1 form-control"
            />
            <button @click="searchBtn" class="btn btn-primary btn-lg">
              {{ $t("common.search") }}
            </button>
          </div>
        </div>
      </div>
      <div style="text-align: right">
        <button
          type="button"
          @click="showEditRoleModal"
          class="btn btn-primary btn-md m-1"
        >
          {{ $t("common.edit") }}
        </button>
        <button
          type="button"
          @click="showAddRoleModal"
          class="btn btn-primary btn-md m-1"
        >
          {{ $t("common.add") }}
        </button>
        <button type="button" @click="deleteRole" class="btn btn-primary btn-md m-1">
          {{ $t("common.delete") }}
        </button>
        <button @click="downExcel()" class="btn btn-secondary btn-md m-1">
          {{ $t("common.excelDownload") }}
        </button>
      </div>
      <table class="list_tbl inner_tb">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                @click="goCheckAll($event.target.checked)"
                class="form-check-input"
                v-model="checkAll"
              />
            </th>
            <th class="mobile_h">{{ $t("management.roleId") }}</th>
            <th class="mobile_h">{{ $t("management.roleName") }}</th>
            <th class="mobile_h">{{ $t("common.description") }}</th>
            <th class="mobile_h">{{ $t("management.menuAuthority") }}</th>
            <th class="mobile_h">{{ $t("management.userManagement") }}</th>
          </tr>
        </thead>
        <tbody v-if="roleList.length != 0">
          <tr v-for="(item, index) in roleList" :key="index">
            <td>
              <input type="checkbox" v-model="item.selected" class="form-check-input" />
            </td>
            <td class="text-left">{{ item.roleId }}</td>
            <td class="text-left">{{ item.roleName }}</td>
            <td class="text-left">{{ item.description }}</td>
            <td>
              <router-link
                :to="{ name: 'roleMenuMgmt', params: { roleId: item.roleId } }"
                class="btn btn-primary btn-sm"
                >{{ $t("management.menu") }}</router-link
              >
            </td>
            <td>
              <router-link
                :to="{ name: 'roleUserMgmt', params: { roleId: item.roleId } }"
                class="btn btn-primary btn-sm"
                >{{ $t("management.user") }}</router-link
              >
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="4">{{ $t("common.noData") }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="roleList.length != 0" class="paging_nav">
        <div class="paging_nav">
          <a
            href="javascript:void(0)"
            v-if="pagingVO.startPage <= pagingVO.blockSize"
            class="page_select prev_page disabled"
            >이전페이지 이동</a
          >
          <a
            v-else
            class="page_select prev_page"
            @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
            v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
            >이전페이지 이동</a
          >
          <span
            v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
            :key="index"
          >
            <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
              pagingVO.startPage + index
            }}</strong>
            <a
              href="javascript:void(0)"
              v-else
              @click="searchPage(pagingVO.startPage + index)"
              >{{ pagingVO.startPage + index }}</a
            >
          </span>
          <a
            v-if="pagingVO.endPage >= pagingVO.totalPage"
            href="javascript:void(0)"
            class="page_select next_page disabled"
            >다음페이지 이동</a
          >
          <a
            v-else
            href="javascript:void(0)"
            @click="searchPage(pagingVO.endPage + 1)"
            v-bind:data-page="pagingVO.endPage + 1"
            class="page_select next_page"
            >다음페이지 이동</a
          >
        </div>
      </div>
    </div>
    <!--------------------------------------------   모달    ---------------------------------------------------------------->
    <CommonModal id="roleModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("management.roleRegister") }}</h3>
      </template>
      <template slot="body">
        <table class="write_tbl responsive_tbl">
          <tbody>
            <tr>
              <th>{{ $t("management.roleId") }}</th>
              <td>
                <input
                  type="text"
                  v-model="roleObj.roleId"
                  name="roleId"
                  v-validate="'required'"
                  class="int_type01"
                  :readonly="readonly"
                />
              </td>
            </tr>
            <tr>
              <th>{{ $t("management.roleName") }}</th>
              <td>
                <input
                  type="text"
                  v-model="roleObj.roleName"
                  name="roleName"
                  v-validate="'required'"
                  class="int_type01"
                />
              </td>
            </tr>
            <tr>
              <th>{{ $t("management.label") }}(ko)</th>
              <td><input type="text" v-model="roleObj.koLabel" class="int_type01" /></td>
            </tr>
            <tr>
              <th>{{ $t("management.label") }}(en)</th>
              <td><input type="text" v-model="roleObj.enLabel" class="int_type01" /></td>
            </tr>
            <tr>
              <th>{{ $t("common.description") }}</th>
              <td>
                <input
                  type="text"
                  v-model="roleObj.description"
                  name="description"
                  v-validate="'required'"
                  class="int_type01"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template slot="footer">
        <button type="button" @click="saveRole" class="btn btn-primary">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </section>
</template>

<script>
import { getRoleList, saveRole, deleteRoleList, downExcel } from "@/api/role";
import CommonModal from "@/components/modal/CommonModal";
export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      roleList: "",
      pagingVO: "",
      deleteList: [],
      form: {
        page: 1,
        searchWord: "",
      },
      roleObj: {},
      checkAll: false,
      confirmYN: false,
      showModal: false,
      readonly: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getRoleList(this.form);
        this.roleList = data.pagingVO.dataList;
        this.pagingVO = data.pagingVO;
        for (let i in this.roleList) {
          this.roleList[i].selected = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async downExcel() {
      let result = await downExcel();
      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "roleList.xls";
      link.click();
      window.URL.revokeObjectURL(url);
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.$store.commit("setPage", page);
      this.fetchData();
    },
    // 검색버튼
    searchBtn() {
      this.form.page = 1;
      this.$store.commit("setSearchWord", this.form.searchWord);
      this.fetchData();
    },
    // 전체선택
    goCheckAll(checked) {
      this.checkAll = checked;
      for (let i in this.roleList) {
        this.roleList[i].selected = this.checkAll;
      }
    },
    // role 추가 show 버튼
    showAddRoleModal() {
      this.roleObj.crudType = "I";
      this.showModal = true;
      this.readonly = false;
    },
    // close 시 모든것 리셋
    closeModal() {
      this.showModal = false;
      this.roleObj = {};
      this.deleteList = [];
    },
    // role 추가/수정
    async saveRole() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      this.confirmYN = confirm(this.$t("alert.save"));
      if (this.confirmYN) {
        try {
          const { data } = await saveRole(this.roleObj);
          if (data.message == null) {
            if (data.duplicate == null) {
              if (data.status) {
                this.roleList = [];
                this.showModal = false;
                alert(this.$t("alert.savedSuccessfully"));
                this.roleObj = {};
                this.fetchData();
              } else {
                alert(this.$t("alert.ErrorPlzcontactManager"));
              }
            } else {
              alert(this.$t("alert.AlreadyExistRole"));
            }
          } else {
            alert(this.$t("alert.plzCheckAllValues"));
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return;
      }
    },
    // 체크한 role 삭제
    async deleteRole() {
      let deleteList = [];
      for (let i in this.roleList) {
        if (this.roleList[i].selected == true) {
          deleteList.push(this.roleList[i]);
        }
      }
      if (deleteList.length > 0) {
        this.confirmYN = confirm(this.$t("alert.delete"));
        if (this.confirmYN) {
          try {
            const { data } = await deleteRoleList(deleteList);
            if (data.status) {
              alert(this.$t("alert.deletedSuccessfully"));
              this.roleList = [];
              this.fetchData();
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          return;
        }
      }
    },
    // 체크한 role 수정
    showEditRoleModal() {
      for (let i in this.roleList) {
        if (this.roleList[i].selected) {
          this.deleteList.push(this.roleList[i]);
          this.roleObj = this.roleList[i];
          this.roleObj.crudType = "U";
        }
      }
      if (this.deleteList.length > 1) {
        alert(this.$t("alert.plzChooseOne"));
        this.deleteList = [];
        this.roleObj = {};
        return;
      } else if (this.deleteList.length == 1) {
        this.readonly = true;
        this.showModal = true;
      }
    },
  },
  mounted() {
    if (this.$store.getters.getSearchWord != "") {
      this.form.searchWord = this.$store.getters.getSearchWord;
      if (this.$store.getters.getPage != 1) {
        this.form.page = this.$store.getters.getPage;
        this.fetchData();
      } else {
        this.fetchData();
      }
    } else {
      this.fetchData();
    }
  },
};
</script>

<style></style>
